<div class="progressbar surface-back radius-plus">
  <div
    class="progressbar-progress button-bg-onback-job radius-plus"
    [ngStyle]="progressStyle()"
  ></div>
</div>
